import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { GrowthBookProvider } from "@growthbook/growthbook-react";

import { growthbook, initGrowthBook } from "../utils/growthbook";

const GrowthBookRootProvider = ({ children }) => {
	useEffect(() => {
		initGrowthBook();
	}, []);

	return <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>;
};

GrowthBookRootProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default GrowthBookRootProvider;
